import { createContext, useContext, useReducer } from "react";

export const defaultAppState = {
  cardType: false,
  displayErrorMessages: [],
  ocr: {
    show: false,
    hasStream: false,
    ccNumber: "",
    month: "",
    year: "",
  },
  ccNumber: "",
  month: "",
  year: "",
  cvc: "",
  name: "",
  zip: "",
  validateTrigger: 0,
  inputsValidated: [],
  ccInputsValidated: false,
  canBeEdited: false,
  isEditing: false,
  shouldRetokenize: false,
};

function creditCardEntryReducer(state, action) {
  let newState = { ...state };

  switch (action.type) {
    case "Set Existing Card Data":
      return { ...newState, ...action.payload };
    case "Set Card Type":
      newState.cardType = action.cardType;
      return newState;
    case "Remove Card Type":
      newState.cardType = false;
      return newState;
    case "Show OCR":
      newState.ocr.show = true;
      return newState;
    case "OCR Has Stream":
      newState.ocr.hasStream = true;
      return newState;
    case "Close OCR":
      newState.ocr.show = false;
      newState.ocr.hasStream = false;
      return newState;
    case "Set Error Message":
      if (newState.displayErrorMessages.includes(action.message))
        return newState;
      newState.displayErrorMessages.push(action.message);
      return newState;
    case "Remove Error Message":
      newState.displayErrorMessages = newState.displayErrorMessages.filter(
        (msg) => msg !== action.message && msg !== "default"
      );
      return newState;
    case "Remove Multiple Error Messages":
      newState.displayErrorMessages = newState.displayErrorMessages.filter(
        (msg) => !action.messages.includes(msg) && msg !== "default"
      );
      return newState;
    case "Clear Display Errors":
      newState.displayErrorMessages = [];
      return newState;
    case "Set Credit Card Number":
      newState.ccNumber = action.number;
      newState.ocr.ccNumber = "";
      return newState;
    case "Set Credit Card Number From OCR":
      newState.ocr.ccNumber = action.number;
      return newState;
    case "Set Expire Date From OCR":
      newState.ocr.month = action.month;
      newState.ocr.year = action.year;
      return newState;

    case "Set Month":
      newState.month = action.month;
      newState.ocr.month = "";
      return newState;
    case "Set Year":
      newState.year = action.year;
      newState.ocr.year = "";
      return newState;

    case "Set CVC":
      newState.cvc = action.cvc;
      return newState;

    case "Set Name":
      newState.name = action.name;
      return newState;

    case "Set Zip":
      newState.zip = action.zip;
      return newState;

    case "Validate All Inputs":
      newState.inputsValidated = [];
      newState.validateTrigger++;
      return newState;

    case "Validating Input Complete":
      newState.inputsValidated.push(action.inputType);
      return newState;

    case "Toggle CC Inputs Validated":
      newState.ccInputsValidated = action.payload;
      return newState;

    case "Set Editing":
      newState.isEditing = action.payload;
      return newState;
    case "Set Should Retokenize":
      newState.shouldRetokenize = action.payload;
      return newState;

    default:
      return newState;
  }
}

export const CreditCardEntryState = createContext();

export function CreditCardEntryProvider({ initialAppState = {}, children }) {
  const appState = { ...defaultAppState, ...initialAppState };
  const value = useReducer(creditCardEntryReducer, appState);
  return (
    <CreditCardEntryState.Provider value={value}>
      {children}
    </CreditCardEntryState.Provider>
  );
}

export default function useCreditCardEntryState() {
  const context = useContext(CreditCardEntryState);
  if (!context) {
    throw new Error(
      "useFlocknoteAppState must be used inside a FlocknoteAppStateProvider"
    );
  }

  return context;
}
